import { call, put, takeEvery } from "redux-saga/effects";
import {
    GET_QUERYBUILDER_PROFILEGROUPS,
    GET_QUERYBUILDER_PROFILES,
    GET_QUERYBUILDER_PROFILEFILTERS
} from "./actionTypes"

import {
  getQueryBuilderProfileGroupListSuccessAction,
  getQueryBuilderProfileListSuccessAction,
  getQueryBuilderProfileFilterListSuccessAction,
  apiQueryBuilderApiErrorAction
} from "./actions"

//Include Both Helper File with needed methods
import {
  getProfileGroupListHelper,
  getProfileListHelper,
  getProfileFilterListHelper
} from "../../helpers/backend_helper/backend_helper"

import { toast,Zoom } from "react-toastify";
import i18n from 'i18n';

function* onGetProfileGroupListSaga() {
  try {
    const response = yield call(getProfileGroupListHelper)
    yield put(getQueryBuilderProfileGroupListSuccessAction(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(apiQueryBuilderApiErrorAction(error))
  }
}

function* onGetProfileListSaga({ payload: guid }) {
  try {
    const response = yield call(getProfileListHelper, guid)
    yield put(getQueryBuilderProfileListSuccessAction(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(apiQueryBuilderApiErrorAction(error))
  }
}

function* onGetProfileFilterListSaga({ payload: guid }) {
  try {
    const response = yield call(getProfileFilterListHelper, guid)
    yield put(getQueryBuilderProfileFilterListSuccessAction(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(apiQueryBuilderApiErrorAction(error))
  }
}

function* queryBuilderManagementSaga() {
    yield takeEvery(GET_QUERYBUILDER_PROFILEGROUPS,onGetProfileGroupListSaga)
    yield takeEvery(GET_QUERYBUILDER_PROFILES,onGetProfileListSaga)
    yield takeEvery(GET_QUERYBUILDER_PROFILEFILTERS,onGetProfileFilterListSaga)
}

export default queryBuilderManagementSaga
